export const FUNDAYLIST_DOMAIN = "fundaylist.com";
export const FUNDAYLIST = "fundaylist";
export const LOCALHOST = "localhost";
export const GRANTED = "granted";
export const DENIED = "denied";
export const PROMPT = "prompt";
export const YOU = "you";
export const DOWNTOWN = "downtown";
export const LOADING = "loading";

export enum FeedStatus {
  INIT = "init",
  LOADING = "loading",
  LOADING_MORE = "loading_more",
  RESULTS = "results",
  NORESULTS = "noresults",
  SCROLLING = "scrolling",
}

export enum FeedListingType {
  ALL = "all",
  ACTIVITY = "activity",
  BAR = "bar",
  EVENT = "event",
  RESTAURANT = "restaurant",
}

export enum ListingType {
  ACTIVITY = "activity",
  BAR = "bar",
  EVENT = "event",
  RESTAURANT = "restaurant",
}

export enum ListingSource {
  OPENTABLE = "opentable",
  VIATOR = "viator",
  GOOGLE = "google",
  PERSON = "person",
  DONETWORK = "donetwork",
  TICKETMASTER = "ticketmaster",
  FACEBOOK = "facebook",
}
export enum InterestTags {
  AMERICAN_FOOD = "american_food",
  AFRICAN_FOOD = "african_food",
  ART_CRAFT = "art_craft",
  ASIAN_FOOD = "asian_food",
  BEER = "beer",
  BRUNCH_CAFE = "brunch_cafe",
  CARIBBEAN_FOOD = "caribbean_food",
  CENTRAL_AMERICAN_FOOD = "central_american_food",
  CLUB = "club",
  COCKTAIL = "cocktail",
  COFFEE = "coffee",
  COMEDY = "comedy",
  DANCING = "dancing",
  DIVE_BAR = "dive_bar",
  EUROPEAN_FOOD = "european_food",
  GAME = "game",
  HEALTHY_LIFESTYLE = "healthy_lifestyle",
  HISTORY_SCIENCE = "history_science",
  KARAOKE = "karaoke",
  LIVE_MUSIC = "live_music",
  MEDITERRANEAN_FOOD = "mediterranean_food",
  MIDDLE_EASTERN_FOOD = "middle_eastern_food",
  MOVIE = "movie",
  NATURE_OUTDOOR = "nature_outdoor",
  OTHER_FUN = "other_fun",
  SEAFOOD = "seafood",
  SHOPPING = "shopping",
  SOUTH_AMERICAN_FOOD = "south_american_food",
  SPORT = "sport",
  SWEET = "sweet",
  THEATER = "theater",
  THRILL_SEEKING = "thrill_seeking",
  WINE = "wine",
}

export enum CrowdTags {
  COLLEGE = "college",
  DOG_FRIENDLY = "dog_friendly",
  KID_FRIENDLY = "kid_friendly",
  LGBTQ = "lgbtq",
}
export enum PriceTags {
  FREE = "free",
  CASH_1 = "cash_1",
  CASH_2 = "cash_2",
  CASH_3 = "cash_3",
}
/* Tag Maps */
export const filtersMap = [
  {
    title: "Fun Types",
    attributeName: "type",
    filterItems: [
      { label: "activities", value: ListingType.ACTIVITY },
      { label: "bars", value: ListingType.BAR },
      { label: "events", value: ListingType.EVENT },
      { label: "restaurants", value: ListingType.RESTAURANT },
    ],
  },
  {
    title: "Crowd",
    attributeName: "crowd_tags",
    filterItems: [
      { label: "college", value: CrowdTags.COLLEGE },
      { label: "dog friendly", value: CrowdTags.DOG_FRIENDLY },
      { label: "kid friendly", value: CrowdTags.KID_FRIENDLY },
      { label: "LGBTQ+", value: CrowdTags.LGBTQ },
    ],
  },
  {
    title: "Price",
    attributeName: "price_tags",
    filterItems: [
      { label: "free", value: PriceTags.FREE },
      { label: "$", value: PriceTags.CASH_1 },
      { label: "$$", value: PriceTags.CASH_2 },
      { label: "$$$", value: PriceTags.CASH_3 },
    ],
  },
];
export const interestsFilterMap = {
  title: "Interests",
  attribute: "interest_tags",
  filterItems: [
    { label: "american food", value: InterestTags.AMERICAN_FOOD },
    { label: "african food", value: InterestTags.AFRICAN_FOOD },
    { label: "art & crafts", value: InterestTags.ART_CRAFT },
    { label: "asian food", value: InterestTags.ASIAN_FOOD },
    { label: "beer", value: InterestTags.BEER },
    { label: "brunch & cafes", value: InterestTags.BRUNCH_CAFE },
    { label: "caribbean food", value: InterestTags.CARIBBEAN_FOOD },
    {
      label: "central american food",
      value: InterestTags.CENTRAL_AMERICAN_FOOD,
    },
    { label: "clubs", value: InterestTags.CLUB },
    { label: "cocktails", value: InterestTags.COCKTAIL },
    { label: "coffee", value: InterestTags.COFFEE },
    { label: "comedy", value: InterestTags.COMEDY },
    { label: "dancing", value: InterestTags.DANCING },
    { label: "dive bars", value: InterestTags.DIVE_BAR },
    { label: "european food", value: InterestTags.EUROPEAN_FOOD },
    { label: "games", value: InterestTags.GAME },
    { label: "healthy lifestyle", value: InterestTags.HEALTHY_LIFESTYLE },
    { label: "history & science", value: InterestTags.HISTORY_SCIENCE },
    { label: "karaoke", value: InterestTags.KARAOKE },
    { label: "live music", value: InterestTags.LIVE_MUSIC },
    { label: "mediterranean food", value: InterestTags.MEDITERRANEAN_FOOD },
    {
      label: "middle eastern food",
      value: InterestTags.MIDDLE_EASTERN_FOOD,
    },
    { label: "movies", value: InterestTags.MOVIE },
    { label: "nature / outdoors", value: InterestTags.NATURE_OUTDOOR },
    { label: "other fun", value: InterestTags.OTHER_FUN },
    { label: "seafood", value: InterestTags.SEAFOOD },
    { label: "shopping", value: InterestTags.SHOPPING },
    {
      label: "south american food",
      value: InterestTags.SOUTH_AMERICAN_FOOD,
    },
    { label: "sports", value: InterestTags.SPORT },
    { label: "sweets", value: InterestTags.SWEET },
    { label: "theater / plays", value: InterestTags.THEATER },
    { label: "thrill seeking", value: InterestTags.THRILL_SEEKING },
    { label: "wine", value: InterestTags.WINE },
  ],
};
/* Interfaces */
export interface ImageI {
  alt?: string;
  base_64_url?: string;
  src: string;
  blur_src?: string;
  is_cropped: string;
  is_fun: string;
}
export interface RegionI {
  border_coordinates: BorderCoordinatesI[];
  name: string;
}

export interface BorderCoordinatesI {
  lat: number;
  long: number;
}
export interface IconI {
  className?: string;
  fill?: string;
}
export interface AffiliateI {
  affiliate_id?: number;
  commission?: number;
  content_url?: string;
  created_time?: string;
  referral_id?: string;
  source?: ListingSource;
  updated_time?: string;
  url: string;
}
export interface GeolocationI {
  geo_center: string;
  radius: string;
  latitude: string;
  longitude: string;
}
export interface LikedListingI {
  id: string;
  type: string;
  subtype: string;
  title: string;
  date: string;
  img_src: string;
}

export interface AppI {
  calendar: {
    dates: Date[];
  };
  city: CityI | undefined;
  geolocation: GeolocationI;
  menu: {
    is_calendar_active: boolean;
    is_main_menu_active: boolean;
    is_filter_menu_active: boolean;
    is_like_menu_active: boolean;
    is_search_active: boolean;
    is_back_button_active: boolean;
    is_interest_menu_active: boolean;
  };

  modal: string;
  pathname: string;
  scrollY: number;
  typesense: {
    active_start_time_unix: string;
    active_end_time_unix: string;
    query: string;
    filters: {
      crowd_tags: string[];
      interest_tags: string[];
      price_tags: string[];
      type: ListingType[];
      [key: string]: string[] | undefined;
    };
    feed: {
      scrollY: number;
    };
  };
}

export interface UserI {
  email: string;
  first_name: string;
  geolocation: {
    longitude: string;
    latitude: string;
  };
  is_admin: boolean;
  is_logged_in: boolean;
  last_name: string;
  liked_listings: LikedListingI[];
  role: string;
}

export interface CityI {
  collection: string;
  coordinates: { lat: number; long: number };
  country: string;
  facebook_url: string;
  ga_id: string;
  images: ImageI[];
  instagram_url: string;
  is_active: boolean;
  name: string;
  regions: RegionI[];
  state: string;
  tagline: string;
  tiktok_url: string;
  timezone: string;
}
export interface PlaceI {
  address: string;
  description: string;
  html: string;
  images: ImageI[];
  place_id: number;
  subtype: string;
  title: string;
  website_url?: string;
}
export interface ActivityI {
  address: string;
  affiliate?: AffiliateI;
  description: string;
  html: string;
  images: ImageI[];
  subtype: string;
  title: string;
}
export interface EventI {
  address: string;
  affiliate?: AffiliateI;
  description: string;
  end_time: string;
  html: string;
  images: ImageI[];
  start_time: string;
  subtype: string;
  title: string;
}
export interface ListingI {
  active_start_time_unix?: number;
  active_start_time?: string;
  active_end_time_unix?: number;
  active_end_time?: string;
  activity?: ActivityI | null;
  address?: string;
  city_region?: string[];
  crowd_tags?: string[];
  description?: string;
  event?: EventI | null;
  google_address?: string;
  html?: string;
  id?: string;
  images?: ImageI[];
  interest_tags?: string[];
  keywords?: string[];
  listing_id?: number;
  location?: number[];
  open_hours?: {
    [key: string]: string;
  };
  place?: PlaceI;
  price_tags?: string[];
  random_ranking?: number;
  rating?: number;
  subtype?: string;
  timezone?: string;
  title?: string;
  type?: string;
  unique_type?: string;
}
